export const iconFontAwesomeGendersVenusMars = (
	<i className="fa-solid fa-venus-mars"></i>
);
